module.exports = __webpack_public_path__ + "static/media/logout.a0549387.png";